module.exports = __webpack_public_path__ + "static/img/P4.84d303b1.jpg";